import { Component, ElementRef, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AlertsService } from '../../services/alerts.service';
import { LoaderService } from '../../services/loader.service';
import { UtilService } from '../../services/util.service';
import { BaseService } from '../../shared/services/base.service';
import { StorageService } from '../../shared/services/storage.service';
import { DialogConfig } from '../dialog/dialog-config';
import { DialogRef } from '../dialog/dialog-ref';

@Component({
    selector: 'app-template-interceptor',
    templateUrl: './template-interceptor.component.html',
    styleUrls: ['./template-interceptor.component.scss'],
    standalone: false
})
export class TemplateInterceptorComponent implements OnInit {
  config = {
    "submitButton": true,
    "cancelButton": false,
    "filterForm": false,
    "clearOnSave": false,
    "delegateSave": true,
    "cancelRoute": ''
  };
  patientDetails:any
  currentData: any = {};
  configForTemplate: any = {
    emitOnSubmit: false,
    singleTemplate: false,
    resource: "templateInterceptor"
  }
  isBypassAllowed: boolean = false
  constructor(
    private baseService: BaseService,
    route: ActivatedRoute,
    private dialogConfig: DialogConfig,
    public alerts: AlertsService,
    public dialog: DialogRef,
    public loader: LoaderService,
    public storageService: StorageService,
    public utilService: UtilService,
    private elementRef: ElementRef
  ) {
  }

  ngOnInit(): void {
    this.loader.showSpinner();
    if (this.dialogConfig.data.config)
      this.configForTemplate = this.dialogConfig.data.config;
    this.currentData['data'] = this.dialogConfig.data.data;
    this.currentData['action'] = this.dialogConfig.data.action;
    this.currentData['data']['next_stage'] = this.currentData['action'].templateInterceptor.next_stage;
    let serviceItemCodeArray = [];
    this.getPatientDetails(this.currentData['data'])
    try {
      this.dialogConfig.data.data.forEach(element => {
        serviceItemCodeArray.push(element.serviceItemCode);
      });
    } catch (error) { }

    let datasource = this.dialogConfig.data.action.templateInterceptor.datasource != undefined ? this.dialogConfig.data.action.templateInterceptor.datasource : {
      "query_id": "GET_TEMPLATE_BY_RESOURCE",
      "application": "form-template-engine",
      "resource": "templateTransaction",
      "args": "serviceType_code:!!!serviceType_code!!!,serviceItemCode:!!!serviceItemCode!!!,stage:!!!next_stage!!!,serviceRequestId:!!!serviceRequestId!!!"
    };
    let args = datasource.args ? this.baseService.buildDyanamicStr(datasource.args, { data: this.currentData['data'] }) : '';
    let filter = datasource.filter ? this.baseService.buildDyanamicStr(datasource.filter, { data: this.currentData['data'] }) : '';
    this.getResource(this.configForTemplate.resource);
    const interceptor = this.currentData?.['action']?.templateInterceptor;
    const configDetails = interceptor?.TemplateData?.[0]?.template_configuration_details;
    const stageConfig = Array.isArray(configDetails) ? configDetails.find(x => x?.stage == interceptor?.next_stage)  : undefined;
    if (stageConfig?.mandatory && this.dialogConfig?.data?.action?.templateInterceptor) {
      this.dialogConfig.data.action.templateInterceptor.accepted = stageConfig.mandatory;
    }
    this.isBypassAllowed = !!stageConfig?.bypass;
    if (this.currentData['action'].templateInterceptor.TemplateData != undefined && this.currentData['action'].templateInterceptor.TemplateData) {
      this.loader.hideSpinner();
      this.currentData['action'].templateInterceptor.TemplateData = this.setConsentAddMoreData(this.currentData['action'].templateInterceptor.TemplateData)
    
    
    //  this.currentData['action'].templateInterceptor.TemplateData = this.setConsentAddMoreData(this.currentData['action'].templateInterceptor.TemplateData)
      let data = this.currentData['action'].templateInterceptor.TemplateData;
      try {
        data.forEach(element => {
          element.serviceItemNameArray = element.serviceItemNameArray.filter(x => (serviceItemCodeArray.includes(x.id)));
        });
      } catch (error) {

      }

      this.currentData['list'] = data;
      if (!this.utilService.isMobile()) {
        this.setView(data[0], 0);
      }
    }
    else {
      this.getData(datasource.query_id, args, datasource.resource, datasource.application, filter, (data) => {
        if (data && data.length > 0) {
          const stageConfig = data[0]?.template_configuration_details?.find(x => x?.stage == this.currentData?.action?.templateInterceptor?.next_stage);
          if (stageConfig?.mandatory && this.dialogConfig?.data?.action?.templateInterceptor) {
            this.dialogConfig.data.action.templateInterceptor.accepted = stageConfig.mandatory;
          }
          this.isBypassAllowed = !!stageConfig?.bypass;
            if (this.currentData['action'].templateInterceptor.addExtrakey) {
              data = this.setConsentAddMoreData(data)
            }   
            this.currentData['list'] = data;
            if (!this.utilService.isMobile()) {
              this.setView(data[0], 0);
            }
        } else {
          this.alerts.info("Create Template First");
          // this.dialog.close(true);
        } //this will process normal flow in case of template was not found
        this.loader.hideSpinner();
      });
    }

  }

  async getData(queryId, args, resource, application, filter, callback?) {
    await this.baseService.get(queryId, args, resource, application, filter).toPromise().then(data => {
      if (data.errCode == -1) {
        if (data.message === "No templates Found") {
          this.loader.hideSpinner();
          this.dialog.close(true);
          return;
        }
        this.alerts.error(data.message);
      }
      else if (data && !data.resource) {
        if (callback) {
          this.loader.hideSpinner();
          console.log("data not found.")
          callback(null);
        }
      }
      else if (data && data.resource != undefined && data.resource.length != undefined) {
        if (callback) {
          callback(data.resource);
        }
      }
    })
  }
  closeButton() {
    this.currentData.show = false;
  }

  setTemplateTransaction(data) {
    try {
      if (data?.serviceItemNameArray && Array.isArray(data.serviceItemNameArray)) { // clinical template
        if (Array.isArray(this.currentData['data'])) {
          let services = this.currentData['data'].filter(x => data.serviceItemNameArray.find(y => y.id == x.serviceItemCode));
          services = services.map(v => ({ ...v, templateTransactionId: data?.id }));
          for (let item of services) {
            let index = this.currentData['data'].findIndex(elem => elem.serviceItemCode == item.serviceItemCode);
            if (index > -1) {
              this.currentData['data'][index] = item;
              this.currentData['questionForm']['patient_id'] = this?.patientDetails?.id ?? item?.id
            }
          }
          // If service is not found, add it
          if (services.length === 0) {
            const updateData = data.serviceItemNameArray.map(item => ({ ...item, templateTransactionId: data?.id }));
            this.currentData['data'].push(...updateData);
            this.currentData['questionForm']['patient_id'] = this?.patientDetails?.id ?? (this.currentData['data'] as any)?.id
          }
        } else { // service has not exits
          this.currentData['data']['templateTransactionId'] = data?.id;
          data['templateTransactionId'] = data?.id;
          this.currentData['questionForm']['patient_id'] = this?.patientDetails?.id ?? this.currentData['data']?.id
        }
      } else {
        if (Array.isArray(data)) {
          const updateData = data.map(item => ({ ...item, templateTransactionId: item?.id }));
          this.currentData['data'] = updateData;
        } else {
          this.currentData['data']['templateTransactionId'] = data?.id;
          data['templateTransactionId'] = data?.id;
          this.currentData['questionForm']['patient_id'] = this?.patientDetails?.id ?? this.currentData['data']?.id
        }
      }
    } catch (error) { }
  } 

 setPrintData(data) {
    data['print_data_array'] = [{ headers: [] }];
    for (let block of data.blocks) {
      for (let field of block.fields) {
        data['print_data_array'][0].headers.push({
          "component": field.component,
          "answer": data.formData[field.name],
          "label": field.label,
          "class_name": field.class_name
        })
      }
    }
  }

  parse(myObj) {
    try {
      for (let key in myObj) {
        if (typeof myObj[key] == 'object') {
          myObj[key] = JSON.stringify(myObj[key])
        }
      }
    } catch (error) {

    }

  }

  onSaveFinished(event) {
    this.parse(event.result);
    if (event.type != undefined && event.type == "skip") {
      // this.dialog.close(true);
    }
    else {
      if (this.currentData['action'].templateInterceptor != undefined && this.currentData['action'].templateInterceptor.appendForm != undefined) {
        this.currentData['questionForm'] = { ...this.currentData['questionForm'], ...this.currentData['action'].templateInterceptor.appendForm }
      }
      this.currentData['questionForm']['formData'] = event.result;
      var actionOnSave = this.currentData['resouceDef'].config && this.currentData['resouceDef'].config.actionOnSave ? this.currentData['resouceDef'].config.actionOnSave : 'FINAL';
      if (this.currentData['action'].templateInterceptor.setPrint != undefined && this.currentData['action'].templateInterceptor.setPrint) {
        this.setPrintData(this.currentData['questionForm']);
      }
      if (this.currentData['action'].templateInterceptor != undefined && this.currentData['action'].templateInterceptor.ApiAction != undefined) {
        this.currentData['questionForm']['templateId'] = this.currentData['questionForm']['parent_template_id'];
        this.currentData['questionForm']['title'] = this.currentData['questionForm']['title'];
        this.currentData['questionForm']["template"] = this.currentData['questionForm']['formData'];
        if (event?.currentBtnVal?.status) {
          this.currentData['questionForm']['consent_status'] = event.currentBtnVal.status
          this.setTemplateTransaction(this.currentData['questionForm']);
        }
        let obj = { ...this.currentData['questionForm'], ...this.currentData['data'] };
        obj['status'] = "final";
        delete obj.id;
        this.postData(obj, this.currentData['action'].templateInterceptor.ApiAction.action, this.currentData['action'].templateInterceptor.ApiAction.application, this.currentData['action'].templateInterceptor.ApiAction.resource, (data) => {
          if (data) { this.dialog.close(true); }
        });
      }
      else {
        if (this.currentData && this.currentData['data'] && this.currentData['data']['facility_id'])
          this.currentData['questionForm']['facility_id'] = this.currentData['data']['facility_id']
        if (event?.currentBtnVal?.status) {
          this.currentData['questionForm']['consent_status'] = event.currentBtnVal.status
          this.setTemplateTransaction(this.currentData['questionForm']);
        }
        this.postData(this.currentData['questionForm'], actionOnSave, 'form-template-engine', 'templateTransaction', (data) => {
          if (data) {
            if (this.currentData['list'][this.currentData['formIndex']] != undefined)
              this.currentData['list'][this.currentData['formIndex']]['formData'] = event.result;
              let formData = this.currentData['list'][this.currentData['formIndex'] + 1] != undefined ? this.currentData['list'][this.currentData['formIndex'] + 1] : false;
            //setting id to the transaction
            this.setTemplateTransaction(data[0]);
            this.setPreRegistrationTemplateTransactionId(data[0])
            if (this.configForTemplate.emitOnSubmit) {
              var emitData = data[0];
              emitData['title'] = this.currentData['questionForm'].title;
              this.dialog.close(emitData);
            }
            else {
              // || (this.currentData['action'].templateInterceptor.emitOnSubmit != undefined && this.currentData['action'].templateInterceptor.emitOnSubmit)
              if (formData) {
                setTimeout(() => {
                  let index = this.currentData['formIndex'] + 1;
                  document.getElementById('labtestList' + index).classList.toggle('doc-active-tab');
                });
                this.setView(formData, this.currentData['formIndex'] + 1);
              }
              else {
                this.skipAll();
              }
            }
          }
          // this.dialog.close(true);
        });
      }


    }
  }

  postData(result, action, application, resource, callback?) {
    this.loader.showSpinner();
    this.baseService.action(result, action, application, resource).subscribe(data => {
      if (data.errCode == -1) {
        this.alerts.error(data.message);
        if (callback) {
          callback(false);
        }
      } else {
        if (!this.currentData['action'].templateInterceptor.hideToaster) {
          this.alerts.success(data.message);
        }
        if (callback) {
          if (!this?.currentData?.data?.uhId && this.currentData?.['questionForm']?.consent_type_id != "clinical_consent") { // self registration
            data.resource = (data.resource ?? []).map(x => ({ ...x, extra_data: { transaction_id: x?.id } }));
            this.configForTemplate.emitOnSubmit = true
          }
          callback(data.resource);
        }
      }
      this.loader.hideSpinner();
    })
  }

  getResource(resource) {
    this.baseService.getResourceDef(resource, (resouceDef) => {
      if (resouceDef) {
        this.currentData['resouceDef'] = resouceDef;
        if (this.currentData['action'] != undefined && this.currentData['action'].templateInterceptor != undefined && this.currentData['action'].templateInterceptor.removeKey != undefined && resouceDef.list.fields != undefined) {
          for (let item of this.currentData['action'].templateInterceptor.removeKey.split(",")) {
            const index = resouceDef.list.fields.findIndex(x => x.name == item);
            if (index > -1) {
              resouceDef.list.fields.splice(index, 1); // 2nd parameter means remove one item only
            }
          }
        }
        this.currentData.fields = resouceDef.list.fields;
      }
    })
  }

  setView(data, i) {
    this.removeClass()
    this.currentData.show = false;
    this.currentData.selectedList = data;
    setTimeout(() => {
      this.setForm(data, i);
    });
  }
  mobileEventCall(data, i) {
    this.removeClass()
    this.currentData.show = false;
    this.currentData.selectedList = data;
    setTimeout(() => {
      this.setForm(data, i);
    });
  }

  setForm(data, i) {
    if (this?.dialogConfig?.data?.action?.transactionStatus) { // Re-Filling Consent Form Via 3Dots
      data.transactionStatus = this.dialogConfig.data.action.transactionStatus
    } 
    let addCheckboxBlockOnIAgree;
    try {
      addCheckboxBlockOnIAgree = this.addMoreCheckBoxViaMaster(data, i);
    } catch (e) {
      console.error(e);
    }
    this.renderForm(addCheckboxBlockOnIAgree || data, i);
  }

  renderForm(data, i) {
    this.currentData.show = true;
    this.currentData['questionForm'] = data; //to do for multiple templates
    this.currentData['questionForm'].submitButton = data.transactionStatus != undefined && data.transactionStatus === "Final" ? false : true;
    // setting empty button for view
    if (data.transactionStatus != undefined && data.transactionStatus === "Final") {
      this.markFieldDisabled(data.blocks);
      this.currentData['btn'] = { "Add": [] };
    }
    else {
      if(this.dialogConfig?.data?.action?.templateInterceptor?.TemplateData?.[0]?.template_configuration_details?.[0]?.mandatory){ //  only accept button showing in mandatory
        this.dialogConfig.data.action.templateInterceptor.accepted = true
      }
      if (this.dialogConfig?.data?.action?.templateInterceptor?.accepted) { // only accept button showing 
        this.currentData['btn'] = {
          "Add": [
            {
              label: 'button.accept',
              status: 'Accepted',
              id:"consent_accept",
              icon: 'fa fa-check'
            }
          ],
        }
      } else if (this.dialogConfig?.data?.action?.templateInterceptor?.addExtrakey) {
        this.currentData['btn'] = {
          "Add": [
            {
              label: 'button.accept',
              status: 'Accepted',
              id:"consent_accept",
              icon: 'fa fa-check'
            },
            {
              label: 'button.reject',
              status: 'Rejected',
              id:"consent_accept",
              icon: 'fa fa-times'
            },
          ],
        }
      }
      else {
        this.currentData['btn'] = {
          "Add": [
            {
              "label": "Submit",
              "id":"consent_accept",
            }
          ]
        }
      }
    }
    const templateInterceptor = this.dialogConfig?.data?.action?.templateInterceptor;
    if (templateInterceptor?.TemplateData?.[0]?.bypass || templateInterceptor?.TemplateData?.[0]?.template_configuration_details?.[0]?.bypass || this.isBypassAllowed) {
      this.currentData['btn']['Add'].push({
        label: 'button.bypass',
        status: 'Pending',
        icon: 'fa fa-forward'
      });
    }
    this.currentData['formData'] = data.formData != undefined ? data.formData : {};
    this.currentData['formIndex'] = i;
  }

  checkPermission(buttons: any) {
    if (buttons.hasOwnProperty("permission_required")) {
      return buttons.permission_required == true ? this.baseService.rolePermissionService.checkAccessPermission(buttons.action_name, buttons.resource, buttons.application) : buttons.permission_required
    } else {
      return true
    }
  }

  removeClass() {
    let child = this.elementRef.nativeElement.getElementsByClassName('doc-view-list');
    for (let cl of child) {
      cl.classList.remove("doc-active-tab");
    }
  }
  onButtonClicked(event, tabInfo?) {
    switch (event.action) {
      case 'skip':
        this.skipAll(tabInfo);
        break;

      default:
        break;
    }

  }

  skipAll(tabInfo?) {
    let i = 0;
    for (let obj of this.currentData['list']) {
      if (obj.template_configuration_details != undefined && obj.template_configuration_details && obj.template_configuration_details.length) {
        let mandatory = obj.template_configuration_details.find(x => x.mandatory != undefined && x.stage == this.currentData['action'].templateInterceptor.next_stage && x.mandatory === true);
        let data = this.currentData.list[i] != undefined && this.currentData.list[i].formData != undefined && this.currentData.list[i].formData ? this.currentData.list[i].formData : {};
        if (mandatory && Object.keys(data).length === 0) {
          setTimeout(() => {
            document.getElementById('labtestList' + i).classList.toggle('doc-active-tab');
          });
          this.alerts.info("You Can't Skip without filling following template");
          this.setView(obj, i);
          break;
        }
        else if (i == this.currentData['list'].length - 1) {
          if ((this.currentData['action'].templateInterceptor.emitOnSubmit != undefined && this.currentData['action'].templateInterceptor.emitOnSubmit)) {
            this.dialog.close(this.currentData['data']);
          }
          else {
            this.dialog.close(true);
          }
          break;
        }
      } else {
        if ((this.currentData['action'].templateInterceptor.emitOnSubmit != undefined && this.currentData['action'].templateInterceptor.emitOnSubmit)) {
          this.dialog.close(true);
        }
      }
      i++;
    }
  }

  markFieldDisabled(fields) {
    if (fields) {
      for (let fields_ of fields) {
        fields_['disabled'] = true;
      }
    }
  }

      setConsentAddMoreData(data) { // New Feature add extra key
          if (!data || !this.currentData?.data) return data;
          const src = Array.isArray(this.currentData['data']) ? this.currentData['data'][0] : this.currentData['data'];
          if (!src) return data;
          // Patient Name
          if (src.name_?.prefix && src.name_?.text) {
            src.patient_name = src.name_.prefix + ' ' + src.name_.text;
          }
          // Patient Gender
          if (!src.patient_gender && !src.gender_id && src.gender) {
            src.patient_gender = src.gender;
          }
          if (src.gender_id && typeof src.gender_id === 'string') {
            src.patient_gender = src.gender_id.charAt(0).toUpperCase() + src.gender_id.slice(1);
          }
          // Add / update data using map
          if (!Array.isArray(data) || data.length === 0) {
            return data;
          }
          let applicationId: any;
          let applicationName: any;
          try {
            applicationId = this.baseService['appService']?.getApplication?.();
            const applications = this.baseService['appService']?._applications;
            const application = applications?.find(x => x.id === applicationId);
            applicationName = application?.application_name;
          } catch (error) {
            // appService access failed, continue without it
          }
          const keys = ['facility_id', 'encounter_id', 'episode_id', 'serviceType_code', 'serviceItemName', 'uhId', 'serviceType',
            'patient_id', 'serviceRequestId', 'orderId', 'assessmentPatientType', 'patient_gender', 'status', 'stage', 'telecom',
            'transaction_type', 'transactionStage', 'discharge_block', 'tat', 'serviceItemNameArray', 'patient_name'];
          return data.map(item => {
            if (!item) return item;

            // Consent Type ID
            if (!item.consent_type_id || item.consent_type_id === "") {
              item.consent_type_id = "clinical_consent";
            }
            // Consent Type Name
            if (!item.consent_type_name || item.consent_type_name === "") {
              item.consent_type_name = "Clinical Consent";
            }
            // Module ID
            if (!item.module_id) {
              item.module_id = applicationId;
            }
            // Module Name
            if (!item.module_name) {
              item.module_name = applicationName;
            }
            // Consent Action
            if (!item.consent_action && src?.currentAction) {
              item.consent_action = src.currentAction === 'patient_update' ? 'Patient Update' : src.currentAction === 'tpa_payer' ? 'TPA Payer' : src.currentAction.toUpperCase();
            }
            keys.forEach(key => {
              if (src?.[key] != null) {
                item[key] = src[key];
              }
            });
            return item;
          });
        }



  addMoreCheckBoxViaMaster(data, i) {
      const multivalue = data?.consent_layout_master_extra_field;
      if (multivalue == undefined || multivalue.length == 0) {
        return;
      }
      if (data.blocks != undefined && data.blocks.length > 0 && !this?.dialogConfig?.data?.action.notToCheckConsent && !data.blocks.some(x=>x.is_i_agree_block)) {
        const baseOrder = data.blocks[data.blocks.length - 1].fields != undefined ? data.blocks[data.blocks.length - 1].fields.length : 0;
        const iAgreeOfBlock = {
          "class_name": "col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 fix",
          "default_open": false,
          "is_i_agree_block": true,
          "fields": multivalue.map((item, index) => ({
            "id": item.id,
            "label": item.text,
            "class_name": "kx-control col-lg-12 col-md-12 col-sm-12 col-xl-12 fix",
            "component": "checkbox",
            "name": item.id,
            "required": false,
            "order": baseOrder + index + 1,
            "componentDisplay": "Check-box",
            "title": item.text,
            "visible": true,
            "type": "String",
          })),
          "title": "",
          "visible": true,
          "layout_type": "no-column",
        }
        data.blocks.push(iAgreeOfBlock);
      }
      return data;
  }


  getPatientDetails(event) {
    let data = Array.isArray(event) ? event[0] : event
    if (data?.uhId) {
      this.baseService.get("GET_PATIENT_BY_UHID", "uhId:" + data.uhId, "patient", "patient-registration").subscribe(res => {
        if (res?.resource?.[0]) {
          this.patientDetails = res.resource[0]
        }
      })
    }
  }

  setPreRegistrationTemplateTransactionId(event) {
    if (event?.consent_action !== "SELF REGISTRATION" || event?.module_id !== "patient-registration") {
      return;
    }
    const userId = this.baseService.authenticationService.getCurrentUser()?.user_id;
    if (!userId) {
      return;
    }
    this.baseService.get("GET_BY_ID", "id:" + userId, "pre_registration", "patient-registration").subscribe(res => {
      const patient = res?.resource?.[0];
      if (patient) {
        this.baseService.action({ ...patient, templateTransactionId: event.id }, "MODIFY", "patient-registration", "pre_registration").subscribe();
      }
    });
  }
}